// @flow

// eslint-disable-next-line import/prefer-default-export
export const ratioToPercentage = (a: number, b: number) => `${((a / b) * 100).toFixed(0)}%`;
